module.exports = __webpack_public_path__ + "static/media/stethoscope.a211ff71.svg";